module.exports = __webpack_public_path__ + "1cac0e27491acd1b3a7da7976abfc09c.png";